import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { State } from '../restoration-hub/types';

const initialState: State = {
  columnOrder: undefined,
};

export default createSlice({
  name: 'My Deleted Items',
  initialState,
  selectors: {
    selectColumnOrder: (state) => state.columnOrder,
  },
  reducers: {
    setColumnOrder: (
      state: State,
      action: PayloadAction<State['columnOrder']>,
    ) => {
      state.columnOrder = action.payload;
    },
  },
});
